import actionTypes from './index';

export default designId => ({ type: actionTypes.ADD_ESTIMATE, payload: { designId } });
